export default __webpack_public_path__ + "static/devices-beb07e34df0ad319bc922f5db06423b7.png";